import { createContext } from 'react';

import { CagingCalendarContextReturnType } from './types/context-return.type';

export const CagingCalendarContext = createContext<CagingCalendarContextReturnType | null>(null);
